<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'About',

    metaInfo: {
      title: 'About Us',
      meta: [
        { vmid: 'description', name: 'description', content: 'Learn about YOOXPLORE – our team, vision, and mission in delivering advanced UAV systems with Anti-Jamming and GNSS-Denied flight capabilities to clients worldwide.' },
        { vmid: 'keywords', name: 'keywords', content: 'YOOXPLORE, about us, UAV manufacturer, drone company, anti-jamming UAV, GNSS-denied flight, drone technology' },
      ],
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'about-team-vision',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
